import axios from "../axios/axios-auth";

export default class FieldsService {
    /**
     * V3
     **/
    isAuthorized(orgId) {
        return axios.get(`/api/v3/organizations/${orgId}/fields/isAuthorized`).then(response => response.data)
    }

    getFieldsSummaryV3(orgId, params) {
        return axios.get(`/agro-service/v1/organizations/${orgId}/fields/summary`, {params: params}).then(response => response.data)
    }

    getFieldsV3(orgId, params) {
        return axios.get(`/agro-service/v1/organizations/${orgId}/fields`, {params: params}).then(response => response.data)
    }

    getNumberOfFieldsV3(orgId) {
        return axios.get(`/agro-service/v1/organizations/${orgId}/fields/number`).then(response => response.data)
    }

    createNewFieldV3(orgId, postObject) {
        return axios.post(`/agro-service/v1/organizations/${orgId}/fields`, postObject).then(response => response.data)
    }

    updateFieldV3(fieldId, postObject) {
        return axios.patch(`/agro-service/v1/fields/${fieldId}`, postObject).then(response => response.data)
    }

    deleteFieldV3(fieldId) {
        return axios.delete(`/agro-service/v1/fields/${fieldId}`).then(response => response.data)
    }

    postShapefileV3(orgId, formData) {
        return axios.post(`/agro-service/v1/organizations/${orgId}/fields/shapefile`, formData, {headers: {'content-type': 'multipart/form-data'}}).then(response => response.data)
    }

    previewShapefileV3(orgId, formData) {
        return axios.post(`/agro-service/v1/organizations/${orgId}/fields/shapefile/preview`, formData, {headers: {'content-type': 'multipart/form-data'}}).then(response => response.data)
    }

    importFieldsV3(orgId, postObject) {
        return axios.post(`/agro-service/v1/organizations/${orgId}/fields/import`, postObject).then(response => response.data)
    }

    detectFields(params) {
        return axios.get('/field-identifier-service/identify', {params: params}).then(response => response.data)
    }

    getFieldsOperations(orgId) {
        return axios.get(`/agro-service/v1/organizations/${orgId}/fields/operations`).then(response => response.data)
    }
}
